import './blog_overview.scss';
import { is_mobile } from 'js/utils';
import Posts_Nav from './posts_nav';
import Posts_List from './posts_list';
import Load_More from 'components/load_more/load_more';

init();
function init(){
    
    const nav = new Posts_Nav('.posts_list_nav');
    
    const list = new Posts_List('.posts_list', {
        query: 'src/modules/blog/overview/query',
    });

    const load_more = new Load_More(list.container, {
        showposts: blog_page_data.showposts,
        total: blog_page_data.found_posts,
        count: blog_page_data.post_count,
    });

    load_more.hooks.add('trigger', (offset)=>{

        load_more.loading();
        
        list.query({
            filter_args: nav.get_value(),
            offset,
            showposts: load_more.showposts,
        }, ()=>{
            setTimeout(()=>load_more.loading_end(), 300);
        })
    })

    nav.hooks.add('update_start', ()=>{
        list.loading();
        list.scroll_top();
    })

    nav.hooks.add('update', ()=>{        
        list.query({
            filter_args: nav.get_value(),
        })
    })

    list.hooks.add('query_result', (res)=>{
                
        if( res.query_args.offset ) {
            list.add_html(res.html);
        }
        else {
            
            list.update_html(res.html);
            
            load_more.update_args({
                total: res.found_posts,
                count: res.post_count,
            })
        }

        list.loading_end();
    })

    document.addEventListener('blog_mobile_filter', ({values})=>{
        list.loading();
        list.scroll_top();
        list.query({
            filter_args: values,
        })
    })

    init_mobile_filter();
}

function init_mobile_filter(){
    
    const load = ()=>{
        if( !is_mobile() ) return;
        import('./filter_mobile')
        window.removeEventListener('resize', load)
    }
    
    window.addEventListener('resize', load)
    load();
    
}